import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

/* Typefaces (BRAND-2): the three the approved design uses — Noto Naskh Arabic
 * for display, Noto Sans Arabic for UI and body, EB Garamond as the one Latin
 * serif. All SIL OFL, all self-hosted; the design fetches them from Google
 * Fonts and we do not, because the standing law is zero Google anything.
 *
 * Plus Jakarta Sans is gone with the old palette: nothing set it once the
 * body face became Noto Sans Arabic, and an imported family nothing uses is
 * bytes every visitor pays for.
 *
 * Every face is declared in styles/fonts.css against stable /fonts/ URLs
 * rather than imported from @fontsource, so index.html can preload the two
 * the first paint needs — the swap used to reflow the header at ~3.1s and was
 * most of the homepage's layout shift. See that file for the detail. */
import "./styles/fonts.css";

import "./styles/design-tokens.css";
import "./styles/tokens.css";
import "./styles/base.css";
/* The generated, partly-scoped copy -- NOT components.css itself. The 29
 * class names the design also defines are prefixed with `.sq-legacy`, which
 * Layout renders inside, so the old stylesheet cannot reach a rebuilt screen.
 * Regenerate with `node scripts/scope-legacy-css.mjs` after editing the
 * source. See that script for the defect this closes. */
import "./styles/components-scoped.css";

/* The design's components, scoped under `.sq-v3` by scripts/scope-design-css.mjs,
 * then the handful of states the design package does not draw. Both load after
 * components.css because a rebuilt screen has to win inside its wrapper, and
 * neither reaches a screen that is not inside one. */
import "./styles/design-components.css";
import "./styles/v3-app.css";
/* The v4-wizard package, scoped under `.sa-wz`. Last, so its tokens win
 * inside that scope; it reaches nothing outside it. */
import "./styles/wizard-components.css";
import "./styles/value-components.css"; // L1b: the v6-lifecycle layer, scoped to .sa-v6
import { App } from "./App";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
